/**
 * @generated SignedSource<<d027038a06c60cdb1d078d6f84fb0418>>
 * @relayHash 73153944db8c578f3e03d3a5a65ac324
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 695d00f1e5c52675e6e4230a5dcdce7c908fd8b54b21d9c9618b8d596071d3db

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
  capabilitiesContainerId: string;
  queryContext?: string | null;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: {
    readonly id: string;
    readonly key: string;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  };
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "picture"
},
v6 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "url"
},
v9 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v12 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v13 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v14 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v15 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v16 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v17 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v18 = [
  (v7/*: any*/),
  (v3/*: any*/)
],
v19 = [
  (v3/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v25 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v24/*: any*/)
  ]
},
v26 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ]
},
v27 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v24/*: any*/)
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "kind"
},
v29 = {
  "kind": "ScalarField",
  "name": "score"
},
v30 = [
  (v22/*: any*/),
  (v29/*: any*/)
],
v31 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v32 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v33 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v34 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v33/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v36 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v37 = {
  "kind": "ScalarField",
  "name": "end"
},
v38 = {
  "kind": "ScalarField",
  "name": "start"
},
v39 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v38/*: any*/)
  ]
},
v40 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v38/*: any*/),
    (v37/*: any*/)
  ]
},
v41 = [
  (v40/*: any*/)
],
v42 = [
  (v22/*: any*/),
  (v3/*: any*/)
],
v43 = {
  "kind": "ScalarField",
  "name": "variance"
},
v44 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v42/*: any*/)
    },
    (v43/*: any*/)
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "type"
},
v46 = {
  "kind": "ScalarField",
  "name": "subType"
},
v47 = {
  "kind": "ScalarField",
  "name": "archived"
},
v48 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v49 = {
  "kind": "ScalarField",
  "name": "source"
},
v50 = {
  "kind": "ScalarField",
  "name": "time"
},
v51 = [
  (v50/*: any*/),
  (v3/*: any*/),
  (v22/*: any*/)
],
v52 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v53 = [
  (v52/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v54 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v55 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v30/*: any*/)
},
v56 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v57 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v58 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v59 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v58/*: any*/)
  ]
},
v60 = {
  "args": (v53/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v22/*: any*/),
            (v50/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v3/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v54/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v19/*: any*/)
                        },
                        (v55/*: any*/),
                        (v3/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v54/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v21/*: any*/),
            (v11/*: any*/)
          ]
        },
        (v56/*: any*/)
      ]
    },
    (v59/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v61 = {
  "args": (v53/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v62 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v42/*: any*/)
},
v63 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v64 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v65 = [
  (v50/*: any*/),
  (v3/*: any*/)
],
v66 = {
  "args": (v53/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v65/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareTargetDateRange",
                  "kind": "LinkedField",
                  "name": "dateRange",
                  "plural": false,
                  "selections": [
                    (v37/*: any*/)
                  ]
                }
              ]
            },
            (v22/*: any*/)
          ]
        },
        (v43/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v67 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v68 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v67/*: any*/),
    (v45/*: any*/)
  ]
},
v69 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v3/*: any*/),
    (v26/*: any*/)
  ]
},
v70 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v65/*: any*/)
},
v71 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v45/*: any*/),
                (v46/*: any*/),
                (v47/*: any*/),
                (v48/*: any*/),
                (v49/*: any*/),
                (v70/*: any*/)
              ]
            },
            (v62/*: any*/),
            (v63/*: any*/),
            (v64/*: any*/)
          ]
        }
      ]
    }
  ]
},
v72 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v30/*: any*/)
},
v73 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v74 = [
  (v11/*: any*/),
  (v33/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v3/*: any*/)
],
v75 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v74/*: any*/)
},
v76 = {
  "kind": "ScalarField",
  "name": "label"
},
v77 = {
  "kind": "ScalarField",
  "name": "summary"
},
v78 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v74/*: any*/)
},
v79 = {
  "kind": "ScalarField",
  "name": "description"
},
v80 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v81 = [
  (v11/*: any*/),
  (v5/*: any*/),
  (v4/*: any*/),
  (v33/*: any*/),
  (v3/*: any*/)
],
v82 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v81/*: any*/)
},
v83 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v81/*: any*/)
},
v84 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v85 = [
  (v54/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v22/*: any*/),
      (v29/*: any*/),
      (v76/*: any*/)
    ]
  },
  (v77/*: any*/),
  (v78/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v77/*: any*/),
              (v79/*: any*/),
              (v47/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v3/*: any*/),
              (v77/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v54/*: any*/),
              (v84/*: any*/)
            ]
          }
        ]
      },
      (v21/*: any*/)
    ]
  },
  (v3/*: any*/)
],
v86 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v88 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v89 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v90 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v87/*: any*/),
          (v88/*: any*/),
          (v77/*: any*/),
          (v89/*: any*/),
          (v54/*: any*/),
          (v3/*: any*/)
        ]
      }
    ]
  }
],
v91 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 30
    }
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": (v90/*: any*/),
  "storageKey": "updates(first:30)"
},
v92 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v93 = [
  (v92/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v94 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v95 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v23/*: any*/)
},
v96 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v41/*: any*/)
},
v97 = [
  (v11/*: any*/),
  (v3/*: any*/)
],
v98 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v97/*: any*/)
  }
],
v99 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v97/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": (v98/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v100 = {
  "args": (v93/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v101 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v102 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v45/*: any*/),
    (v67/*: any*/)
  ]
},
v103 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v104 = {
  "args": (v103/*: any*/),
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": (v90/*: any*/),
  "storageKey": "updates(first:10)"
},
v105 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v79/*: any*/)
],
v106 = [
  (v52/*: any*/)
],
v107 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v108 = [
  (v22/*: any*/),
  (v50/*: any*/),
  (v3/*: any*/)
],
v109 = [
  (v76/*: any*/),
  (v40/*: any*/)
],
v110 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v4/*: any*/),
                (v3/*: any*/),
                (v33/*: any*/),
                (v5/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v89/*: any*/),
            (v54/*: any*/)
          ]
        }
      ]
    },
    (v21/*: any*/)
  ]
},
v111 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v77/*: any*/),
      (v79/*: any*/),
      (v82/*: any*/),
      (v83/*: any*/),
      (v54/*: any*/),
      (v84/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v112 = [
  (v92/*: any*/),
  (v9/*: any*/)
],
v113 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v98/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v6/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "args": (v10/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            }
          ]
        },
        "action": "THROW"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          },
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  },
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v13/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              (v15/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v12/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v17/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v4/*: any*/),
                          (v8/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v18/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalIcon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "name": "appearance"
              }
            ]
          },
          (v4/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v3/*: any*/),
              (v26/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v3/*: any*/),
                  (v25/*: any*/),
                  (v27/*: any*/)
                ]
              },
              (v28/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v29/*: any*/),
              {
                "concreteType": "TownsquareCompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v30/*: any*/)
              }
            ]
          },
          (v31/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v32/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              (v39/*: any*/),
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareTargetDate",
                                    "kind": "LinkedField",
                                    "name": "date",
                                    "plural": false,
                                    "selections": (v41/*: any*/)
                                  },
                                  (v22/*: any*/),
                                  (v11/*: any*/),
                                  (v44/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v3/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v49/*: any*/),
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": (v51/*: any*/)
                          },
                          (v21/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/)
                        ]
                      },
                      (v62/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v66/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          (v68/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v68/*: any*/),
                      (v3/*: any*/),
                      (v69/*: any*/),
                      (v32/*: any*/),
                      (v71/*: any*/),
                      (v8/*: any*/),
                      (v72/*: any*/),
                      (v4/*: any*/),
                      (v35/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      (v47/*: any*/),
                      (v31/*: any*/),
                      (v73/*: any*/),
                      (v75/*: any*/),
                      (v86/*: any*/),
                      (v91/*: any*/),
                      {
                        "args": (v93/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v32/*: any*/),
                                  (v4/*: any*/),
                                  (v8/*: any*/),
                                  (v94/*: any*/),
                                  (v95/*: any*/),
                                  (v96/*: any*/),
                                  (v34/*: any*/),
                                  (v11/*: any*/),
                                  (v99/*: any*/)
                                ]
                              },
                              (v56/*: any*/),
                              (v11/*: any*/)
                            ]
                          },
                          (v59/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v100/*: any*/)
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "args": (v101/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v102/*: any*/),
                      (v47/*: any*/),
                      (v3/*: any*/),
                      (v32/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v27/*: any*/),
                          (v3/*: any*/),
                          (v26/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      (v72/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v70/*: any*/),
                                      (v60/*: any*/),
                                      (v61/*: any*/)
                                    ]
                                  },
                                  (v62/*: any*/),
                                  (v63/*: any*/),
                                  (v64/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareTargetDate",
                                                "kind": "LinkedField",
                                                "name": "date",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/)
                                                ]
                                              },
                                              (v22/*: any*/),
                                              (v44/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      (v31/*: any*/),
                      (v73/*: any*/),
                      (v75/*: any*/),
                      (v86/*: any*/),
                      (v17/*: any*/),
                      (v104/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v13/*: any*/)
                        ]
                      },
                      (v35/*: any*/),
                      (v36/*: any*/)
                    ]
                  },
                  (v11/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/),
              (v68/*: any*/),
              (v71/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v23/*: any*/)
              },
              (v4/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v35/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v79/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v58/*: any*/),
                  (v57/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v54/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v105/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v21/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v105/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v21/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v105/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "args": (v106/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v3/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v4/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  (v56/*: any*/)
                                ]
                              },
                              (v59/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v106/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v21/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v17/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v79/*: any*/),
                                  {
                                    "args": (v106/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v3/*: any*/),
                                              (v22/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "args": (v106/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v11/*: any*/)
                                    ]
                                  },
                                  (v56/*: any*/)
                                ]
                              },
                              (v59/*: any*/),
                              (v21/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v106/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v21/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v47/*: any*/),
          {
            "args": (v107/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v77/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v77/*: any*/),
                                  (v79/*: any*/),
                                  (v3/*: any*/),
                                  (v47/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/),
                      (v54/*: any*/),
                      (v87/*: any*/),
                      (v88/*: any*/),
                      (v55/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v77/*: any*/),
                                  (v79/*: any*/),
                                  (v11/*: any*/),
                                  (v3/*: any*/),
                                  (v80/*: any*/),
                                  (v82/*: any*/),
                                  (v83/*: any*/),
                                  (v54/*: any*/),
                                  (v84/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v49/*: any*/),
                                      (v70/*: any*/),
                                      {
                                        "args": [
                                          (v52/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v108/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v108/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v51/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          (v47/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v38/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v22/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v3/*: any*/),
                          (v31/*: any*/),
                          (v47/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v27/*: any*/),
                                  (v3/*: any*/)
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v45/*: any*/)
                            ]
                          },
                          {
                            "args": (v101/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v47/*: any*/),
                                      (v68/*: any*/),
                                      (v71/*: any*/),
                                      (v8/*: any*/),
                                      (v31/*: any*/),
                                      (v73/*: any*/),
                                      (v75/*: any*/),
                                      (v86/*: any*/),
                                      (v17/*: any*/),
                                      (v32/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v25/*: any*/),
                                          (v27/*: any*/),
                                          (v26/*: any*/),
                                          (v3/*: any*/)
                                        ]
                                      },
                                      (v72/*: any*/),
                                      (v104/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v47/*: any*/),
                                      (v68/*: any*/),
                                      (v69/*: any*/),
                                      (v71/*: any*/),
                                      (v8/*: any*/),
                                      (v31/*: any*/),
                                      (v73/*: any*/),
                                      (v75/*: any*/),
                                      (v86/*: any*/),
                                      (v32/*: any*/),
                                      (v72/*: any*/),
                                      (v91/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v103/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v77/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v77/*: any*/),
                                                  (v79/*: any*/),
                                                  (v3/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          }
                        ]
                      },
                      (v78/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v109/*: any*/)
                      },
                      {
                        "args": (v101/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v67/*: any*/)
                                    ]
                                  },
                                  (v3/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v85/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v102/*: any*/),
                                  (v71/*: any*/),
                                  (v8/*: any*/),
                                  (v31/*: any*/),
                                  (v73/*: any*/),
                                  (v75/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v33/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      (v89/*: any*/),
                      (v8/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v3/*: any*/),
                                      (v4/*: any*/),
                                      (v33/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v19/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v19/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v3/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v110/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v30/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v109/*: any*/)
                      }
                    ]
                  },
                  (v56/*: any*/)
                ]
              },
              (v59/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": "updates(first:20)"
          },
          {
            "args": (v107/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "concreteType": "TownsquareGoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v65/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v3/*: any*/)
            ]
          },
          (v79/*: any*/),
          (v110/*: any*/),
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "isWatching"
          },
          {
            "args": (v93/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v11/*: any*/),
                  (v56/*: any*/),
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      (v95/*: any*/),
                      (v34/*: any*/),
                      (v99/*: any*/),
                      {
                        "concreteType": "TownsquareProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "_id",
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          },
                          (v3/*: any*/)
                        ]
                      },
                      (v32/*: any*/),
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v94/*: any*/),
                      (v96/*: any*/)
                    ]
                  }
                ]
              },
              (v59/*: any*/),
              (v21/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v100/*: any*/),
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v111/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v111/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v111/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "args": (v112/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v77/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v56/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v59/*: any*/),
              (v21/*: any*/)
            ]
          },
          {
            "args": (v112/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v20/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v97/*: any*/)
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v113/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v113/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v113/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "updateStreak_extension"
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "695d00f1e5c52675e6e4230a5dcdce7c908fd8b54b21d9c9618b8d596071d3db",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "37cb59172c08685bfd671c0530663aa3";

export default node;
